module["exports"] = [
  "##-###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/postcode.js
 ** module id = 837
 ** module chunks = 0
 **/